export default __webpack_public_path__ + "static/media/pat_dimitri.4d4c14b0.png";